import { render } from "./MenuOptions.vue?vue&type=template&id=7940f82a&scoped=true"
import script from "./MenuOptions.vue?vue&type=script&lang=js"
export * from "./MenuOptions.vue?vue&type=script&lang=js"

import "./MenuOptions.vue?vue&type=style&index=0&id=7940f82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7940f82a"]])

export default __exports__